import { wrappedGet } from './urlFuncs';
import { DASHBOARD_STATS } from './../inc/constants';
import { API_URL } from './../inc/config';

export const getDashboardStats = () =>{
  return wrappedGet(`${API_URL}${DASHBOARD_STATS}`, 'GET');
}
